import _JSXStyle from "styled-jsx/style";
import React from 'react';
import GridBasicItem from './basic-item';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const defaultProps = {
  className: ''
};

const Grid = ({
  children,
  className,
  ...props
}) => {
  const {
    className: resolveClassName,
    styles
  } = {
    styles: /*#__PURE__*/_jsx(_JSXStyle, {
      id: "2841698183",
      children: ".jsx-2841698183{margin:0;box-sizing:border-box;padding:var(--grid-gap-unit);}"
    }),
    className: "jsx-2841698183"
  };
  return /*#__PURE__*/_jsxs(GridBasicItem, {
    className: `${resolveClassName} ${className}`,
    ...props,
    children: [children, styles]
  });
};

Grid.defaultProps = defaultProps;
export default /*#__PURE__*/React.memo(Grid);